export default __webpack_public_path__ + "static/twitter_wide-3252b1d42c607e02966c293156bbe1f5.png";